import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { vehicleCategoryIconSvg } from '../ui/vehicle-type-icons';

export function renderAssistOffer(target: HTMLElement): void {
  const grid = createEl('div', { className: 'sv-vehicle-grid' });

  for (const cat of SITE.vehicleScopeCategories) {
    const iconWrap = document.createElement('div');
    iconWrap.className = 'sv-vehicle-card__icon';
    iconWrap.innerHTML = vehicleCategoryIconSvg(cat.id);

    grid.appendChild(
      createEl('article', { className: `sv-vehicle-card sv-vehicle-card--${cat.id}` }, [
        iconWrap,
        createEl('h4', { className: 'sv-vehicle-card__title' }, [cat.title]),
        createEl('p', { className: 'sv-vehicle-card__caption' }, [cat.caption]),
      ])
    );
  }

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-section--surface sv-assist-offer',
      id: 'presta-asistencia',
      'aria-labelledby': 'assist-offer-title',
    },
    [
      createEl('div', { className: 'sv-inner' }, [
        createEl('p', { className: 'sv-assist-offer__eyebrow' }, [SITE.assistOfferEyebrow]),
        createEl('h2', { className: 'sv-assist-offer__title', id: 'assist-offer-title' }, [SITE.assistOfferTitle]),
        createEl('p', { className: 'sv-assist-offer__body' }, [SITE.assistOfferBody]),
        createEl('div', { className: 'sv-vehicle-scope' }, [
          createEl('h3', { className: 'sv-vehicle-scope__title' }, [SITE.vehicleScopeTitle]),
          createEl('p', { className: 'sv-vehicle-scope__intro' }, [SITE.vehicleScopeIntro]),
          grid,
        ]),
      ]),
    ]
  );

  target.appendChild(section);
}
